import { createHttpClient } from '@systemeio/util';
export const httpClient = createHttpClient();
httpClient.interceptors.response.use(response => response.data);
